module.exports = __webpack_public_path__ + "img/sCaiShen_350x350.9329f475.jpg";